import { breakpoints, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const Wrapper = styled.div``;

export const ModalHeader = styled.div`
  display: none;
  @media (min-width: ${breakpoints.md}) {
    display: block;
    min-height: 60px;
    border-bottom: 1px solid ${theme.color.border.divider};
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${breakpoints.md}) {
    flex-direction: row;
  }
`;
